import {
    setInputRequestProcessors,
    setResponseHandlers,
    setStore,
    setSettings,
    sendRequest,
    sendExtensibleRequest,
    getReducer,
    handleResponseProcessing
} from '../modules/lib-alme-request/src/lib-alme-request';

export {
    setInputRequestProcessors,
    setResponseHandlers,
    setStore,
    setSettings,
    sendRequest,
    sendExtensibleRequest,
    getReducer,
    handleResponseProcessing
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/ref/lib-alme-request.js